import formatDateLocale from '../../../helper/formatDateLocale'

export default (props) => {
  const { value, formatStr = 'P', currentLanguage } = props
  console.log("value date", value)
  return value ? formatDateLocale(currentLanguage, value, formatStr) : ''
}
